/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Detail_UnbilledInputs */



/**
* | output |
* | --- |
* | "{amount} unbilled" |
*
* @param {Partner_Detail_UnbilledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_unbilled = /** @type {((inputs: Partner_Detail_UnbilledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_UnbilledInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} nicht fakturiert`)
	return /** @type {LocalizedString} */ (`${i?.amount} unbilled`)
});